(function() {
    'use strict';
 
 a3_pilot_reports.factory('PilotReportLocalEditCreatorFactory', PilotReportLocalEditCreatorFactory);
    
    /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name PilotReportLocalEditCreatorFactory
    * @description 
    *  Create a new local Report
    * @ngInject
    */
function PilotReportLocalEditCreatorFactory($log, localStorageMD5Service, FlightFactory, ReportGuidFactory, PilotReportTemplateFactory,
			PilotReportLocalEditFactory, UserFactory, GroundServicesFactory, acuSupportingAcTypes){

		
		var service = {
			createNewLocalReportForFlight : createNewLocalReportForFlight
		}      
        
        /**
         * Create a new Local Report For the Selected Flight
         * @memberof PilotReportLocalEditCreatorFactory
         * @param {number} flightId 
         * @returns {object} report 
         */
	function createNewLocalReportForFlight(flightId,flightAimsId){
		
		// load the user
		var user = UserFactory.getUser();
		if (user == null)
			return null;
		
		// check if a report exists for this flight and user
		var existingReport = PilotReportLocalEditFactory.getPilotReportLocalEditForFlight(flightId);
		if (existingReport != null)
			return existingReport;
		
		// get a guid for the report
		var newReportGuid = ReportGuidFactory.getNextGuid();
		if (newReportGuid == null)
			return null;		

		// load the pilot report template
		var reportTemplate = PilotReportTemplateFactory.getPilotReportTemplateFromStorage();
		if (reportTemplate == null)
			return null;

		// load the flight
		var flight = FlightFactory.getFlightFromStorage(flightId,flightAimsId);
		if (flight == null)
		{
			// if not found, also check the local flights
			var flight = FlightFactory.getLocalFlightFromStorage(flightId,flightAimsId);
			
			// if still not found, then return null
			if (flight == null)
				return null;
		}

		// create the new report
		var newReport = PilotReportLocalEditFactory.getNewReport();
		
		// assign data on the new report
		newReport.AuthorId = user.id;
		newReport.AuthorAimsId = user.aimsId;
		newReport.AuthorName = user.name;
		newReport.Created = new Date();
		newReport.FlightAimsId = flight.FlightAimsId;
		newReport.FlightId = flight.FlightId;
		newReport.LastUpdated = new Date();
		newReport.AcType = flight.AcType;
		newReport.AcTailNo = flight.AcTailNo;
		newReport.FlightDate = flight.FlightDate;
		newReport.FlightNo = flight.FlightNo;
		newReport.Departure = flight.Departure;
		newReport.Arrival = flight.Arrival;
		newReport.ScheduledDeparture = flight.ScheduledDeparture;
		newReport.ScheduledDepartureDateUTC = flight.ScheduledDepartureDateUTC;
		newReport.ScheduledDepartureTimeUTC = flight.ScheduledDepartureTimeUTC;
		newReport.ReportGuid = newReportGuid;
		newReport.ReportId = null;
		newReport.NothingToReport = false;
		newReport.Status = 'pending';
		newReport.Sections = reportTemplate.Sections;
		//details from flight (assuming flight contains these fields)
				
				
		if (flight.DepartureName){
			newReport.DepartureICAO = flight.DepartureICAO;
			newReport.DepartureCountry = flight.DepartureCountry;
			newReport.DepartureName = flight.DepartureName;
			newReport.ArrivalICAO = flight.ArrivalICAO;
			newReport.ArrivalCountry = flight.ArrivalCountry;
			newReport.ArrivalName = flight.ArrivalName;
		}
		//pax figures from flight (assuming flight contains these figures)
		if (typeof  flight.BookedY != 'undefined'){
			newReport.BookedC = flight.BookedC;
			newReport.BookedY = flight.BookedY;
			newReport.BookedInf = flight.BookedInf;
			newReport.BookedPad = flight.BookedPad;
			newReport.BookedChld = flight.BookedChld;
			newReport.ActualC = flight.ActualC;
			newReport.ActualY = flight.ActualY;
			newReport.ActualInf = flight.ActualInf;
			newReport.ActualPad = flight.ActualPad;
			newReport.ActualChld = flight.ActualChld;
		}
		newReport.crew = flight.crew;
		
						
		//new values
		newReport.DepartureTimezone=flight.DepartureTimezone;
		newReport.ArrivalTimezone=flight.ArrivalTimezone;
		newReport.CallSign=flight.CallSign;
		newReport.ScheduledArrival=flight.ScheduledArrival;
		newReport.DepartureGate=flight.DepartureGate;
		
		//add ground services
		newReport.DepartureGroundServices = GroundServicesFactory.getGroundServicesByStation(flight.Departure);
		//We don't show Arrival Services any more...
		//newReport.ArrivalGroundServices = GroundServicesFactory.getGroundServicesByStation(flight.Arrival);

		//ACU provision
		if (acuSupportingAcTypes.includes(flight.AcType) && (flight.Departure == 'ATH' || flight.Departure == 'SKG' || flight.Departure == 'PAS')){		
			newReport.ACUProvision.isRequired = true;
		}

		newReport.updateTotals();
		
		// return the new report
		return newReport;
	}

		return service;
};

 
 })();   